// extracted by mini-css-extract-plugin
export default {"Sidebar":"Sidebar_Sidebar__rWGto","OpenSidebar":"Sidebar_OpenSidebar__AwMrB","CloseSidebar":"Sidebar_CloseSidebar__i0WUe"};